'use client'

import { device } from '@mercadoni/sinister/dist/cjs/shared/utils'
import { Col } from 'antd'

import goToSearchV2 from '@/navigation/CSR/goToSearchV2/goToSearch'
import defaultLocale from '@/stores/defaultLocale'
import getLocale from '@/stores/locales'
import { ClientModel } from '@mercadoni/sinister/dist/lib/src/entities/clientModel'
import { useRouter } from 'next/navigation'
import { IParamsByUrl } from '~types/search'
import useWindowMobile from '../useCases/useWindowMobile'
import SortSelector from './SortSelector'
const SortCol = (props: {
  selectedSort: string
  clientConfig: ClientModel
  userAgent?: string
  urlParams: IParamsByUrl
}) => {
  const router = useRouter()
  const copy = getLocale() || defaultLocale
  const sortOptionsConfig = props.clientConfig?.sortOptions || []

  const goToPath = async (value: string) => {
    await goToSearchV2({
      router,
      urlParams: props.urlParams,
      action: 'sortSelected',
      value,
    })
  }

  const isScreenMobile = useWindowMobile()
  const isMobile = device(props.userAgent).isMobile()

  if (isMobile || isScreenMobile) {
    return null
  }

  return (
    <Col flex="250px">
      <SortSelector
        copy={copy?.filter || {}}
        onChangeToSort={goToPath}
        sortOptionsConfig={sortOptionsConfig}
        defaultValue={props.selectedSort}
      />
    </Col>
  )
}

export default SortCol
